/* eslint @typescript-eslint/explicit-function-return-type: off */

import PropTypes from 'prop-types';
import ApplicationModel from '../ApplicationModel';

const MATCHING_RULES = [
  'equals',
  'not_equals',
  'matches',
  'not_matches',
  'be_blank',
  'be_present',
];

// 値の有無のみで判定するため sourceColumnValue を必要としないルール
// (バックエンドの ExclusionCondition::RULES_WITHOUT_VALUE と対応)
const RULES_WITHOUT_VALUE = ['be_blank', 'be_present'];

const propTypes = {
  ...ApplicationModel.propTypes,
  sourceColumnName: PropTypes.string,
  matchingRule: PropTypes.oneOf(MATCHING_RULES),
  sourceColumnValue: PropTypes.string,
};

const initialProps = () => ({
  sourceColumnName: '',
  matchingRule: MATCHING_RULES[0],
  sourceColumnValue: '',
});

class ExclusionCondition extends ApplicationModel {
  static MATCHING_RULES = MATCHING_RULES;
  static RULES_WITHOUT_VALUE = RULES_WITHOUT_VALUE;
  static propTypes = propTypes;
  static initialProps = initialProps;

  get options() {
    // 値の有無のみで判定するルールは sourceColumnValue 不要
    if (RULES_WITHOUT_VALUE.includes(this.matchingRule)) {
      return {};
    }

    return { sourceColumnValue: { isRequired: true } };
  }
}

export default ExclusionCondition;
